class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.qty-input__input');
  }

  connectedCallback() {
    this.plusButton = this.querySelector('.qty-input__btn[name="plus"]');
    this.minusButton = this.querySelector('.qty-input__btn[name="minus"]');
    this.currentQty = parseInt(this.input.value, 10) || 1;
    this.buyInMultiples = parseInt(this.input.getAttribute('buy-in-multiples'), 10) || 1;

    
    this.changeEvent = new Event('change', { bubbles: true });
    
    if (!this.plusButton.hasAttribute('data-listener-attached')) {
      this.plusButton.addEventListener('click', this.incrementQuantity.bind(this));
      this.plusButton.setAttribute('data-listener-attached', 'true');
    }

    if (!this.minusButton.hasAttribute('data-listener-attached')) {
      this.minusButton.addEventListener('click', this.decrementQuantity.bind(this));
      this.minusButton.setAttribute('data-listener-attached', 'true');
    }

    this.input.addEventListener('focus', QuantityInput.handleFocus);
    this.input.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  incrementQuantity() {
    this.currentQty = parseInt(this.input.value, 10);
    const newQty = Math.ceil(this.currentQty / this.buyInMultiples) * this.buyInMultiples + this.buyInMultiples;
    this.input.value = newQty;
    this.dispatchChangeEvent();
  }

  decrementQuantity() {
    this.currentQty = parseInt(this.input.value, 10);
    let newQty = Math.floor(this.currentQty / this.buyInMultiples) * this.buyInMultiples - this.buyInMultiples;
    if (newQty < this.buyInMultiples) {
      newQty = this.buyInMultiples; 
    }
    this.input.value = newQty;
    this.dispatchChangeEvent();
  }

  dispatchChangeEvent() {
    this.input.dispatchEvent(this.changeEvent);
  }

  static handleFocus(evt) {
    if (window.matchMedia('(pointer: fine)').matches) {
      evt.target.select();
    }
  }

  handleKeydown(evt) {
    if (evt.key !== 'Enter') return;
    evt.preventDefault();

    if (this.input.value !== this.currentQty) {
      this.input.blur();
      this.input.focus();
      this.currentQty = parseInt(this.input.value, 10);
    }
  }
}

customElements.define('quantity-input', QuantityInput);
